import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import cancelarEncomenda from '../../actions/encomenda/cancelarEncomenda';
import {formatarReal, realParaNumber} from '../../util/numberUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoCancelamentoEncomenda extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoEncomenda')
      .modal('hide');
    $('#modalConfirmacaoCancelamentoEncomenda')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.cancelarEncomenda(values.observacao, this.props.empresaSelecionada.id, this.props.encomenda.id)
      .then(() => {
          showSuccessMsg('Pedido cancelado com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirTaxaCancelamento () {
    let estorno = 0.00;
    if (this.props.encomenda.custoCancelamento) {
      estorno = realParaNumber(this.props.encomenda.valor) - realParaNumber(this.props.encomenda.custoCancelamento);
    }

    return <div className="form-row ml-2">
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Total:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {formatarReal(this.props.encomenda.valor)}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Taxa:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {formatarReal(this.props.encomenda.custoCancelamento)}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Estorno:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {estorno
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
    </div>

  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoEncomenda" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoEncomenda" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">
                {this.props.encomenda
                  ?
                  <React.Fragment>
                    {this.exibirTaxaCancelamento()}
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea} validate={[required]} className="form-control" label="Motivo do cancelamento:"/>
                  </React.Fragment>
                  : ''}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    encomenda: state.encomenda,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarEncomenda
})(reduxForm({
  form: 'formularioCancelamentoEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoEncomenda));
